import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Divider,
  TextField,
} from "@mui/material";
import { ListItem, List, ListItemText } from "@mui/material";
export const FormCard = (props: any) => {
  const { title, description, child, copy } = props;
  return (
    <Container maxWidth={false}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12}>
          <Card>
            <ListItem sx={{ p: 3 }}>
              <ListItemText
                primaryTypographyProps={{
                  variant: "h5",
                  gutterBottom: true,
                }}
                secondaryTypographyProps={{
                  variant: "subtitle2",
                  lineHeight: 1,
                }}
                primary={title}
                secondary={description}
              />
              {!!copy && copy}
            </ListItem>
            <Divider />
            <Grid container>
              <Grid item xs={12}>
                <CardContent>{child}</CardContent>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
